// This file manages exports from the base atom, molecule, or organism.
// Use named rather than default exports.
import dynamic from 'next/dynamic';

export const MapAndRegionCardEditable = dynamic(() =>
  import('./MapAndRegionCard').then(module => module.MapAndRegionCardEditable)
);
export const MapAndRegionCard = dynamic(() => import('./MapAndRegionCard').then(module => module.MapAndRegionCard));
